<template>
  <div class="header">
    <div class="header-content">
      <div class="header-nav">
        <div class="header-logo" @click.stop="routerPath()">
          <div class="logo">
            <img src="../assets/images/logo4.png" alt="">
          </div>
        </div>
        <div class="header-right">
          <div class="header-search">
            <el-input @keyup.enter.native="searchBtn" class="input-with-search" size="small " placeholder="请输入您想搜索的关键词" v-model="search"></el-input>
            <el-button type="primary" icon="el-icon-search" @click="searchBtn">搜索</el-button>
          </div>
          <div class="lang-select">
            <el-button type="text" :style="language === 'zh' ? 'color:blue' : 'color:#333'" @click.stop="handleSelectLang('zh')">简</el-button>
            <div>/</div>
            <el-button type="text" :style="language === 'en' ? 'color:blue' : 'color:#333'" @click.stop="handleSelectLang('en')">EN</el-button>
          </div>
          <div class="menu-select">
            <div class="line1"></div>
            <div class="line2"></div>
            <div class="line3"></div>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="header-bottom" ref="headerBottom" :style="style">
        <ul class="header_ul">
          <li v-for="(menu,index) in menuList" :key="index">
            <router-link :to="{path:menu.path,query:menu.query || {}}">
              <div>{{$t(menu.lang)}}<i v-if="menu.children" class="el-icon-arrow-down" style="margin-left: 5px;"></i></div>
            </router-link>
            <ul class="list_ul" v-if="menu.children">
                <li v-for="(item, key) in menu.children" :key="key+600" @click="tempalte(item)">
                  {{$t(item.lang)}}
                </li>
              </ul>
          </li>
        </ul>
        <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1">{{$t('header.home')}}</el-menu-item>
          <el-submenu index="2">
            <template slot="title">{{$t('header.news')}}</template>
            <el-menu-item index="2-1" v-for="(item, index) in newsClassList" :key="index" @click="tempalte(item)">{{item.classificationName}}</el-menu-item>
          </el-submenu>
          <el-menu-item index="3">{{$t('header.product')}}</el-menu-item>
          <el-menu-item index="4">{{$t('header.honor')}}</el-menu-item>
          <el-menu-item index="4">{{$t('header.party')}}</el-menu-item>
          <el-menu-item index="4">{{$t('header.about')}}</el-menu-item>
          <el-menu-item index="4">{{$t('header.culture')}}</el-menu-item>
        </el-menu> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "Header",
  props: {
    msg: String
  },
  data(){
    return {
      activeIndex: '/index',
      search:'',
      classList: [],
      classList2: [],
      index:0,
      style:"",
      menuList:[]
    }
  },
  computed: mapState({
    language: state => state.language,
    routerMap: state => state.routerMap
  }),
  created(){
    this.getMenus();
  },
  mounted(){
    this.$nextTick(()=>{
      window.addEventListener('scroll',()=>{
        this.style = {
            position:'relative'
          }
        const top = document.documentElement.scrollTop;
        if(top > 70){
          this.style = {
            position:'fixed',
            top:0
          }
        }
      })
    })
    
  },
  methods: {
    getMenus(){
      const queryMap = this.getQueryMap()
      this.menuList = [
        {
          lang:'header.home',
          pathName:'Index',
          path:'/index',
          children:null
        },
        {
          lang:queryMap['News'].lang,
          pathName:queryMap['News'].routeName,
          path:queryMap['News'].path,
          query:{classificationId:queryMap['News'].id} ,
          children:[
            {
              lang:queryMap['GongSiXinWen'].lang,
              template:1,
              classificationId:queryMap['GongSiXinWen'].id
            },
            {
              lang:queryMap['HangYeDongTai'].lang,
              template:1,
              classificationId:queryMap['HangYeDongTai'].id
            },
            {
              lang:queryMap['YuanGongXinDe'].lang,
              template:1,
              classificationId:queryMap['YuanGongXinDe'].id
            }
          ]
        },
        {
          lang:queryMap['Product'].lang,
          pathName:queryMap['Product'].routeName,
          path:queryMap['Product'].path,
          query:{classificationId:queryMap['Product'].id},
          children:null
        },
        {
          lang:'header.honor',
          pathName:'Honor',
          path:'/honor',
          children:null
        },
        {
          lang:queryMap['Party'].lang,
          pathName:queryMap['Party'].routeName,
          path:queryMap['Party'].path,
          query:{classificationId:queryMap['Party'].id},
          children:null
        },
        {
          lang:'header.about',
          pathName:'About',
          path:'/about',
          children:null
        },
        {
          lang:queryMap['Culture'].lang,
          pathName:queryMap['Culture'].routeName,
          path:queryMap['Culture'].path,
          query:{classificationId:queryMap['Culture'].id},
          children:null
        }
      ]
    },
    getQueryMap(){
      let map = {};
      this.routerMap.forEach(i => {
        map[i.name] = i;
      })
      return map;
    },
    getQuery(key,value){
      let info = this.routerMap.find(i => i[key] == value)
      return info;
    },
    tempalte(e){      
      let path = '/thematic_list/template_' + e.template
      this.$router.push({
        path,
        query: {
          classificationId: e.classificationId
        }
      })
    },
    tempalte2(e){
      this.$router.push({
        path: '/video_list/video_' + e.template,
        query: {
          classificationId: e.classificationId
        }
      })
    },
    routerPath(){
      this.$router.push({
        path: '/'
      })
    },
    // 搜索
    searchBtn(){
      if (this.search) {
        this.$router.push({
          path:'/search',
          query:{
            value:this.search
          }
        })
        this.search = ''
      }
    },
    handleCommand(command){
      if(command==='onese'){
        this.$router.push({path:"/oneseif"})
      }else if(command=='uploading'){
        this.$router.push({path:"/uploading"})
      }else if(command=='logout'){
        this.$store.dispatch('logout').then(()=>{
          this.$router.push({path:"/login"})
        })
      }
    },
    handleSelectLang(lang){
      // const language = this.$store.state.language;
      this.$i18n.locale = lang
      this.$store.dispatch('setLanguage', lang)
      // const message = this.$t('message.selectlang')
      // this.$message({
      //   message ,
      //   type: 'success'
      // })
    }
  }
};
</script>

<style scoped lang="less">
  .header{
    width:100%;
    background:#fff;
    z-index: 999;
    position: relative;
    top:0;
    left:0;
    text-align: center;
    .header-content{
      box-sizing: border-box;
      height: 100%;
      .header-nav{
        display: flex;
        height: 100px;
        width: 1200px;
        margin: 0 auto;
        align-items: center;
        justify-content: space-between;
        position: relative;
        .header-logo{
          display: flex;
          height: 100%;
          align-items: center;
          &:hover{
            cursor: pointer;
          }
          img{
            height:90px;
            margin-right: 24px;
          }
          .title{
            vertical-align: middle;
            text-align: left;
            line-height: 38px;
            font-size: 24px;
            font-weight: 500;
            .titleItem{
              margin: 0 5px;
            }
          }
        }
        .header-search{
          border:1px solid #0D53B7;
          display: flex;
          align-items: center;
          height: 44px;
          border-radius: 5px;
            .input-with-search{
              
              ::v-deep input{
                border:none;
                width: 318px;
                height: 100%;
                font-size: 16px;
              }
              
          }
          .el-button--primary{
            color: #FFF;
            background-color: #0D53B7;
            border-color: #0D53B7;
            height: 100%;
            line-height: 40px;
            /* padding: 0; */
            padding-top: 0;
            // border-radius: 0;
            font-size: 20px;
          }
        }
        .menu-select{
          display:none;
        }
      }
      .line{
        width:100%;
        height: 1px;
        background:#ccc;
      }
      .header-bottom{
        height: 66px;
        width: 100%;
        background: #fff;
        margin: 0 auto;
        left: 0;
        padding-bottom: 4px;
          .header_ul{
            width: 1200px;
            display: flex;
            list-style: none;
            margin:0 auto;
            padding:0;
            height: 100%;
            line-height: 80px;
            // margin-left:40px;
            &>li{
              position: relative;
              text-align: center;
              flex:1;
              a{
                padding: 0 14px;
                text-decoration: none;
                color: #0F55B7;
                font-size: 18px;
                transition:all .4s;
                display: inline-block;
                height: 100%;
                width: 100%;
                position: relative;
                &:hover{
                  color:#fff;                  
                  background: #4A69CE;
                  transition:all .4s;
                }
                div{
                      display: inline-block;
                      position: absolute;
                      width: 100%;
                      height: auto;
                      left: 50%;
                      top: 50%;
                      line-height: 26px;
                      transform: translate(-50%,-50%);
                  
                }
              }
              .list_ul{
                width: 100%;
                display: none;
                transition:all .4s;
              }
              i{
                transform:rotate(0);
                transition:all .4s;
                font-size: 14px;
              }
              &:hover{
                i{
                  transform:rotate(180deg);
                  transition:all .4s;
                }
                .list_ul{
                  display: block;
                  box-shadow: 0 6px 12px rgba(0,0,0,.175);
                  position: absolute;
                  top:62px;
                  min-width:120px;
                  left:0;
                  text-align: left;
                  background:#fff;
                  z-index: 99;
                  transition:all .4s;
                  li{
                    width:100%;
                    height:40px;
                    line-height: 40px;
                    color:#333;
                    font-size: 14px;
                    display: block;
                    width: 100%;
                    padding:0 10px;
                    margin:0;
                    cursor: pointer;
                    &:hover{
                      color:#fff;
                      background:#4A69CE;
                    }
                    .router-link-active{
                      color:#fff;
                      background:#0F55B7;
                    }
                  }
                }
            }
            .router-link-active{
              color:#fff;
              background-color: #0F55B7;
            }
          }
        }
      }
      .header-right{
        display: flex;
        
        // div:nth-child(2){
        //   padding:0 30px;
        // }
        .portrait{
          padding-top:11px;
          line-height: 0;
          .el-avatar--circle{
            border:solid 1px #eee;
          }
        }
      }
    }
    .lang-select{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: -10%;
      // z-index: 5;
      width: 60px;
      display: flex;
      align-items: center;
      font-size: 16px;
      div:nth-child(2){
        margin:0 10px;
      }
    }
  }
  .mobile{
    .line,.header-search,.lang-select,.header-bottom{
      display:none!important;
    }
    .menu-select{
      display:block;
      .line1,.line3{
        width:20px;
        height: 2px;
      }
      .line2{
        width:14px;
        height: 2px;
      }
    }
  }
</style>
